import React, { useContext, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";

import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";

import { brandIcons } from "assets/BrandIcons";
import MapImageUrl from "assets/map2_540x.png";
import BG2 from "assets/nature_background_2.png";
import data from "data/product_data.json";
//
import ProductList from "components/features/ProductList";
import HomeImage from "assets/homeImageMedium.jpg";
import TimesSquareEntrance from "assets/store/TimesSquareEntrance.jpg";
import StoreFront from "assets/store/storefront.jpg";
import Storeoutside from "assets/store/storeoutside.png";
import RedsenolPicture from "assets/homepage/redsenol.png";
import { getTranslation } from "translation/translationService";
import { LanguageContext } from "context/LanguageContextProvider";
import TwoImageColumn from "components/features/TwoImageColumn";
import VerticalWithAlternateImageAndText from "components/features/VerticalWithAlternateImageAndText";
import Cnpa from "assets/homepage/cnpa.png";
import classnames from "classnames";

const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg text-blue-400 underline`;

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8 `;

  const StyledLink = styled.a`
    ${tw`flex relative items-center border-black/10 border-2 rounded-full w-48 h-48 justify-center`}
    aspect-ratio: 1/1;
    &:hover {
      ${tw`bg-green-100`}
    }
  `;
  const StyledNotLink = styled.div`
    ${tw`flex relative items-center w-48 h-48 justify-center`}
    aspect-ratio: 1/1;
  `;

  const [state, dispatch] = useContext(LanguageContext);

  const language = state.language.code;
  const homeText = getTranslation(language, "homePage");
  const locationRef = useRef(null);

  return (
    <AnimationRevealPage disabled>
      <Hero
        heading={
          <>
            {homeText.homeHeader1}{" "}
            <HighlightedText>{homeText.homeHeader2}</HighlightedText>
          </>
        }
        description={homeText.homeHeaderDescription}
        imageSrc={HomeImage}
        imageDecoratorBlob={true}
        primaryButtonText={homeText.productLink}
        primaryButtonUrl="/products"
        onClick={() =>
          locationRef?.current?.scrollIntoView({
            behavior: "smooth",
          })
        }
      />
      {/* <Hero3D /> */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="w-full pt-8 text-5xl flex justify-center flex-wrap gap-1">
          {homeText.expoloreOur}
        </div>

        <div className=" pt-8 flex flex-wrap justify-center gap-4 max-w-screen-xl mx-auto">
          {brandIcons
            .filter(({ name }) => !!name)
            .map(({ image, name }) => (
              <StyledLink
                key={name}
                href={`/products/?brand=${name}`}
                target="_blank"
              >
                <img
                  key={name}
                  style={{ transform: "scale(0.5)" }}
                  src={image}
                  alt="brand image"
                />
              </StyledLink>
            ))}
        </div>
        <div className="flex justify-center flex-wrap gap-4">
          {brandIcons
            .filter(({ name }) => !name)
            .map(({ image }) => (
              <StyledNotLink>
                <img
                  key={image}
                  style={{ transform: "scale(0.5)" }}
                  src={image}
                  alt="brand image"
                />
              </StyledNotLink>
            ))}
        </div>
      </div>
      <VerticalWithAlternateImageAndText
        cards={[
          {
            imageSrc: RedsenolPicture,
            subtitle: homeText.redsenol.subtitle,
            title: homeText.redsenol.title,
            url: "https://enophyto.com/retail-locations",
            linkName: homeText.redsenol.description,
          },
          {
            imageSrc: Cnpa,
            subtitle: homeText.cnpa.subtitle,
            title: homeText.cnpa.title,
            description: homeText.cnpa.description,
          },
        ]}
      />
      <div className="flex items-center justify-center flex-row gap-5 w-full pt-10 ml-[5vw]">
        <div className="flex items-center flex-col">
          <img
            style={{ height: "40vw" }}
            src={Storeoutside}
            className="rounded-3xl"
            alt="Store Outside"
          />
        </div>
        <div className="flex items-center flex-col">
          <img
            style={{ height: "40vw", width: "60vw" }}
            src={StoreFront}
            className="rounded-3xl"
            alt="Store Front"
          />
        </div>
      </div>
      <div id="Location" ref={locationRef} />
      {/* ref={locationRef} */}
      <MainFeature2
        subheading={<Subheading>{homeText.reputedStore}</Subheading>}
        heading={
          <>
            {homeText.where1}{" "}
            <HighlightedText>{homeText.where2}</HighlightedText>
          </>
        }
        description={homeText.daysOfWeek}
        statistics={[
          {
            value: "550 Hwy 7, Richmond Hill, UNIT 18",
            key: "ON L4B 3Z4",
          },
        ]}
        primaryButtonText={homeText.getDirections}
        primaryButtonUrl="https://goo.gl/maps/Q1hNv5aD6Zc7c9Nu6"
        imageInsideDiv={true}
        imageSrc={MapImageUrl}
        imageDecoratorBlob={true}
        textOnLeft={true}
        iframeContent={
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1438.760737308672!2d-79.3838433!3d43.845019099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2b4bbf136629%3A0x48d81acbe07091be!2sTimes%20Square%20Richmond%20Hill!5e0!3m2!1sen!2sca!4v1737833407526!5m2!1sen!2sca"
            loading="lazy"
            className="absolute top-0 left-0 w-full h-full"
          ></iframe>
        }
      />
      <div className="flex justify-around flex-nowrap flex-row text-white">
        <img
          style={{ maxHeight: "50vh" }}
          src={TimesSquareEntrance}
          className="rounded-3xl"
          alt="Timesquare Entrance"
        />
      </div>
      <MainFeature2
        subheading={<Subheading>{homeText.reputedStore}</Subheading>}
        heading={
          <>
            {homeText.contactUs1}{" "}
            <HighlightedText>{homeText.contactUs2}</HighlightedText>
          </>
        }
        description={[""]}
        statistics={[
          {
            value: homeText.phoneNumber,
            key: "905-886-1688",
          },
          {
            value: homeText.email,
            key: "info@comeforhealth.ca",
          },
        ]}
        imageInsideDiv={true}
        textOnLeft={false}
        disableButton={true}
      />
      <ProductList unparsedTabs={{ All: data }} />
      <Footer />
    </AnimationRevealPage>
  );
};
